import {UI} from "../../../stem-core/ui/UIBase";
import {UserProfile} from "../../../client/state/UserProfileStore.js";
import {EndpointPaginator} from "../../../stem-core/state/pagination/EndpointPaginator";
import {SimpleTable} from "../../../dashboard/ui/SimpleTable.jsx";
import {Select, TextInput} from "../../../stem-core/ui/input/Input.jsx";
import {Link} from "../../../stem-core/ui/primitives/Link";
import {DashboardTitle} from "../../../dashboard/common/DashboardTitle.js";
import {UserType} from "../../../client/state/UserProfileStore.js";


interface UserFilterOptions {
    paginator?: EndpointPaginator<UserProfile>;
}

class UserFilter extends UI.Element<UserFilterOptions> {
    declare typeSelect: Select<UserType>;
    declare userSearchInput: TextInput;

    render() {
        const updateFilter = () => this.updateFilter();

        return [
            <Select ref="typeSelect" options={["Any", ...UserType.all()]}
                        style={{margin: 10}}
                        onChange={updateFilter}/>,
            <TextInput ref="userSearchInput" style={{height: "2.03em", margin: 10, verticalAlign: "middle"}}
                       placeholder="Search by email or name"
                       onChange={updateFilter} />

        ];
    }

    updateFilter() {
        const {paginator} = this.options;
        const userType = this.typeSelect.getValue();
        const filters = {
            nameOrEmailSearch: this.userSearchInput.getValue() || null,
            userType: (userType instanceof UserType) ? userType : null,
        }

        paginator.updateFilter(filters);
    }
}

export class UsersPage extends UI.Element {
    paginator = new EndpointPaginator(UserProfile, "admin/users/list", {
        order: "-createdAt",
    });

    render() {
        const columns = [
            ["Email", (user: UserProfile) => <Link href={`/users/${user.id}`}>{user.getEmail()}</Link>],
            ["Name", (user: UserProfile) => user.getName()],
            ["Type", (user: UserProfile) => user.userType],
            ["Date Joined", (user: UserProfile) => user.createdAt],
            ["Last Login", (user: UserProfile) => user.lastLogin],
            ["Active", (user: UserProfile) => user.isActive],
            ["Referral merchant", (user: UserProfile) => user.referralMerchant],
        ];

        return [
            <DashboardTitle title={"Users"}/>,
            <UserFilter paginator={this.paginator}/>,
            <SimpleTable paginator={this.paginator} columns={columns}/>,
        ];
    }
}
